import { DASHBOARD_MAP, DASHBOARD_SCREEN, toV2Route } from "@/constants/routes";

export function legacyDashboardTarget(
  pathname: string,
  search: string,
  isAdminAsset: boolean,
  hash = ""
): string {
  const path = pathname.replace(/\/$/, "");
  const mapEntry =
    path === DASHBOARD_MAP || (!isAdminAsset && path === DASHBOARD_SCREEN);
  return `${mapEntry ? toV2Route(DASHBOARD_MAP) : toV2Route(pathname)}${search}${hash}`;
}
